<template>
	<div>
		<h4>Tarifario</h4>
		<b-form-row>
			<b-form-group class="col-md-3" label="Tarifario de *">
				<b-form-select v-model="filters.type" :options="typeOpts"></b-form-select>
			</b-form-group>
			<b-form-group class="col-md-3" label="Proveedor"  v-if="filters.type==='supplier'">
				<multiselect
						v-model="filters.suppliersSelected"
						:options="suppliersOpts"
						label="text"
						multiple
						placeholder="Seleccione"
						taggable
                        track-by="value"
				/>
			</b-form-group>
			<b-form-group class="col-md-3" label="Canal de venta" v-if="filters.type==='salesChannel'">
				<multiselect
						v-model="filters.salesChannelsSelected"
						:options="$root.auxVars.salesChannelsOpts"
						label="text"
						multiple
						placeholder="Seleccione"
						taggable
                        track-by="value"
				/>
			</b-form-group>
			<b-form-group class="col-md-3" label="Punto de venta *" v-if="filters.type==='pointOfSale'">
				<multiselect
						v-model="filters.pointOfSalesSelected"
						:options="$root.auxVars.pointOfSalesOpts"
						label="text"
						multiple
						placeholder="Seleccione"
						taggable
                        track-by="value"
				/>
			</b-form-group>
			<b-form-group class="col-md-3" label="Fecha">
				<b-form-datepicker
						locale="es"
						reset-button
						v-model="filters.date"

				/>
			</b-form-group>

			<b-form-group class="col-md-3" label="Zona Shuttle Central">
				<Multiselect
							class="multiselect"
							label="text"
							:selectLabel="null"
							ref="zone-selector"
							openDirection="top"
							track-by="value"
							multiple
							:options="zonedAreasOptions"
							v-model="filters.zonedAreas"
						/>
			</b-form-group>

			<b-col md="12 text-right">
				<b-overlay :show="loadingExport"  no-wrap rounded> </b-overlay>
				<b-button @click="search()" variant="primary" class="mt-4 ml-4" :disabled="disableButtons"><md-icon icon=""/>Buscar</b-button>
				<b-button v-if="$hasPermission('report.export.xls')" @click="excel()" variant="success" class="mt-4 ml-4" :disabled="disableButtons"><md-icon icon=""/>Descargar excel</b-button>
			</b-col>
		</b-form-row>

		<b-row>
			<div v-if="loading">
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
				<b-spinner small label="Small Spinner" type="grow"></b-spinner>
			</div>
			
			<b-col class="col-md-12 mt-4" v-if="!loading">
				<div class="table-responsive async-tables mt-3" v-if="showHtmlTable" >
					<b-row>
						<b-col>
							<span v-if="table.body.length>0">Mostrando {{(pagination.perPage>table.body.length)?table.body.length:pagination.perPage}} de {{table.body.length}} registros </span>
						</b-col>
						<b-col> 
							<b-pagination 
							class="float-right"
							v-model="pagination.currentPage"
							:total-rows="table.body.length"
							:per-page="pagination.perPage"
							aria-controls="my-table"
							>
							</b-pagination>
						</b-col>
					</b-row>
					
					

					<b-table  
					show-empty
					hover  
					:items="table.body" 
					:fields="table.header"
					id="my-table" 
					:current-page="pagination.currentPage" 
					:per-page="pagination.perPage">

					</b-table>
				</div>
			</b-col>
		</b-row>

	</div>
</template>

<script>
	import api from '../../../../api.js'
	import Multiselect from 'vue-multiselect';
	export default {
		name: "rates",
		components:{Multiselect},
		data(){
			return {
				loading:false,
				loadingExport:false,
				codeReport : "rates",
				filters:{
					date:"",
					type:"supplier",
					suppliersSelected:[],
					salesChannelsSelected:[],
					pointOfSalesSelected:[],
					zonedAreas:[]
				},
				typeOpts:[ {value:"supplier",text:"Proveedores"},{value:"salesChannel",text:"Canales de venta"},{value:"pointOfSale",text:"Punto de venta"}],
				masterZonedAreasOpt:[],
				table:{
					body:[],
					header:[]
				},
				pagination:{
					currentPage:1,
					perPage:100

				},
				showHtmlTable:false
			}
		},
		methods:{
			search(){
				this.loading = true
				this.showHtmlTable =false;
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filtersClean
					}
				}).then((res) => {
					this.showHtmlTable =true;
					this.table.body = res.data.body
				}).catch(error => {
					this.$root.handleRequestError(error)
				}).finally(()=>{this.loading = false});

			},

			excel(){
				this.loadingExport = true
				api(this).get(`/reports/${this.codeReport}`,{
					params:{
						filters:this.filtersClean,
						format:"excel"
					},
					responseType: "blob"
				}).then((res) => {
					this.$root.downloadExcel(res, "Tarifario");
				}).catch(error => {
					console.log(error);
					let errorNew = new Error(["Verifique la información"]);
					this.$root.handleRequestError(errorNew)
				}).finally(()=>{this.loadingExport = false});

			},
			getMasterZonedAreas() {

			if (this.masterZonedAreasOpt.length > 0) {
				return true;
			}

			this.$root.api
				.get(`zoned-areas/master`)
				.then(({data})=>{
					data.forEach(zonedArea => {
						this.masterZonedAreasOpt.push({
							text: zonedArea.name,
							value: zonedArea.id
						})
					})
				})
				.catch((e)=> {
					console.error('ERROR => load master zoned areas', e.message)
				})
		},
			

		},
		mounted() {
			this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['suppliersOpts','salesChannelsOpts','pointOfSalesOpts']})
			this.getMasterZonedAreas()
		},
		computed:{
			filtersClean(){
				let obj = {
					suppliersSelected:this.suppliersIds,
					salesChannelsSelected:this.salesChannelsIds,
					pointOfSalesSelected:this.pointOfSalesIds,
					date:this.filters.date,
					zonedAreasSelected:this.zonedAreasIds
				};
				return {...this.filters,...obj}
			},
			suppliersOpts(){
				return this.$root.auxVars.suppliersOpts;
			},
			suppliersIds(){
				return this.filters.suppliersSelected.map(a => a.value);
			},
			salesChannelsIds(){
				return this.filters.salesChannelsSelected.map(a => a.value);
			},
			pointOfSalesIds(){
				return this.filters.pointOfSalesSelected.map(a=>a.value);
			},
			zonedAreasIds(){
				return this.filters.zonedAreas.map(a=>a.value);
			},
			zonedAreasOptions() {
				return this.masterZonedAreasOpt;
			},
			disableButtons(){
				return (this.loading || this.loadingExport)
			}
		}

	}
</script>

<style scoped>

</style>
